<template>
    <el-select @change="changeStatus()"
               v-model="val"
               size="mini">
        <!--<el-option label="Inactive"
                   :key="userIndex + '0'"
                   value="0"></el-option>
        <el-option label="Active"
                   :key="userIndex + '1'"
                   value="1"></el-option>
        <el-option label="Block"
                   :key="userIndex + '2'"
                   value="2"></el-option>-->

        <el-option
                v-for="item in formatData.statuses"
                :key="item.id"
                :label="item.title"
                :value="+item.id"
                :disabled="disabled"
        ></el-option>


    </el-select>
</template>

<script>
  export default {
    name: 'StatusUserChanging',
    props:{
      userIndex: Number,
      userData: Object,
      formatData: Object,
      disabled: Boolean,
    },
    data () {
      return {
        val: 1
      }
    },
    watch:{
      userIndex: function (val) {
        this.val = this.userData.status_id
      }
    },
    created(){
      this.val = this.userData.status_id
    },
    methods:{
      changeStatus(){
        this.$store.dispatch('users/updateUser', {id:this.userData.id, data: {status_id: this.val} })
      }
    }
  }
</script>

<style scoped>

</style>
